import React from "react";
import {
  FaReact, FaNodeJs, FaApple, FaAndroid, FaRobot, FaServer, FaLaptopCode,
  FaPlug, FaDatabase, FaProjectDiagram, FaPuzzlePiece, FaCode, FaAws,
  FaHandshake, FaBrain, FaCloud, FaUsers, FaBolt, FaMicrochip, FaSitemap,
  FaSearch, FaMagic, FaComments, FaCheckCircle, FaChalkboardTeacher, FaSyncAlt,
  FaLock, FaStream,
} from "react-icons/fa";
import {
  SiAngular, SiTypescript, SiJavascript, SiHtml5, SiCss3, SiMongodb,
  SiExpress, SiNestjs, SiTailwindcss, SiFramer, SiNextdotjs, SiRedux, SiGraphql,
  SiDocker, SiGithubactions, SiPostgresql, SiRedis, SiAmazondynamodb, SiOpenai,
  SiJest, SiIonic, SiSocketdotio, SiAmazons3, SiSalesforce, SiAmazonaws,
} from "react-icons/si";

// One place to map a tech / topic name to its icon.
export const techIcons = {
  // frontend
  React: <FaReact />,
  "React Native": <FaReact />,
  "Next.js": <SiNextdotjs />,
  Angular: <SiAngular />,
  Ionic: <SiIonic />,
  JavaScript: <SiJavascript />,
  TypeScript: <SiTypescript />,
  "Redux / Zustand": <SiRedux />,
  HTML5: <SiHtml5 />,
  CSS3: <SiCss3 />,
  "Tailwind CSS": <SiTailwindcss />,
  "Framer Motion": <SiFramer />,
  // backend
  "Node.js": <FaNodeJs />,
  NestJS: <SiNestjs />,
  Express: <SiExpress />,
  REST: <FaPlug />,
  "REST APIs": <FaPlug />,
  GraphQL: <SiGraphql />,
  WebSockets: <SiSocketdotio />,
  Microservices: <FaSitemap />,
  "Event-Driven Design": <FaBolt />,
  Salesforce: <SiSalesforce />,
  // cloud
  AWS: <FaAws />,
  "AWS Lambda": <SiAmazonaws />,
  "API Gateway": <FaServer />,
  S3: <SiAmazons3 />,
  "SQS / SNS": <FaStream />,
  EventBridge: <FaBolt />,
  Cognito: <FaLock />,
  CDK: <FaAws />,
  Docker: <SiDocker />,
  "GitHub Actions": <SiGithubactions />,
  // data
  PostgreSQL: <SiPostgresql />,
  MongoDB: <SiMongodb />,
  DynamoDB: <SiAmazondynamodb />,
  Redis: <SiRedis />,
  SQL: <FaDatabase />,
  // AI
  OpenAI: <SiOpenai />,
  "OpenAI API": <SiOpenai />,
  "LLM Integration": <FaBrain />,
  "Function Calling": <FaMagic />,
  RAG: <FaSearch />,
  Embeddings: <FaMicrochip />,
  "Prompt Engineering": <FaComments />,
  "Copilot & Cursor": <FaRobot />,
  AI: <FaRobot />,
  // practices
  "System Design": <FaProjectDiagram />,
  TDD: <FaCheckCircle />,
  "Jest & RTL": <SiJest />,
  "Code Reviews": <FaSyncAlt />,
  "Agile / Scrum": <FaSyncAlt />,
  Mentoring: <FaChalkboardTeacher />,
  "Data Structures": <FaProjectDiagram />,
  "Problem Solving": <FaPuzzlePiece />,
  // platforms & service icons
  iOS: <FaApple />,
  Android: <FaAndroid />,
  web: <FaLaptopCode />,
  server: <FaServer />,
  handshake: <FaHandshake />,
  brain: <FaBrain />,
  cloud: <FaCloud />,
  users: <FaUsers />,
};

export const iconFor = (name) => techIcons[name] || <FaCode />;
